import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

// router
import { withRouter } from 'react-router-dom'

const ItemArticuloModalEtiquetas = ({ stockSucursal, onAddArticulo }) => {
    const articulo = stockSucursal.articulo

    const handleAdd = () => {
        const codigoBarra =
            articulo.codigosBarra?.[0]?.codigo || articulo.codigoBarra || ''

        const precioUnidad =
            stockSucursal.precioFinal !== 0
                ? stockSucursal.precioFinal
                : articulo.precioFinal !== 0
                    ? articulo.precioFinal
                    : articulo.precioFinalCalculado

        onAddArticulo({
            articuloId: articulo.id,
            codigo: articulo.codigo,
            nombre: articulo.nombre,
            codigoBarra: codigoBarra.trim(),
            precio: Number(precioUnidad) || 0,
        })
    }

    const codigoBarra =
        articulo.codigosBarra?.[0]?.codigo || articulo.codigoBarra || ''
    const hasCodigoBarra = Boolean(codigoBarra.trim())

    const precioUnidad =
        stockSucursal.precioFinal !== 0
            ? stockSucursal.precioFinal
            : articulo.precioFinal !== 0
                ? articulo.precioFinal
                : articulo.precioFinalCalculado

    return (
        <tr>
            <th scope="row">{articulo.codigo}</th>
            <td>{articulo.nombre}</td>
            <td>${Number(precioUnidad).toFixed(2)}</td>
            <td>{stockSucursal.cantidad}</td>
            <td>
                <button
                    type="button"
                    className="btn text-success"
                    onClick={handleAdd}
                    title={hasCodigoBarra ? 'Agregar a etiquetas' : 'El artículo no tiene código de barra'}
                    disabled={!hasCodigoBarra}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemArticuloModalEtiquetas)
